module.exports = __webpack_public_path__ + "img/训练极速ico.ce64c6f4.png";